import { Button, Layout, theme, Form, Input, Spin, notification, Select, Radio, TimePicker } from "antd";
import React, { useState } from "react";
import "../CreateRole/CreateRole.css";
import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import TextArea from "antd/es/input/TextArea";
import StorageSuggestionApi from "../../common/Apis/StorageListApi";
import { AudioOutlined, LoadingOutlined } from "@ant-design/icons";
import DepartmentDropdown from "../../common/DropDowns/Department";
import SensorsStockPage from "../../common/DropDowns/Stock/SensorsStockPage";
import dayjs from 'dayjs';
import ReportsApi from "../../common/Apis/ReportsApi";

const AddStorageList = () => {
  const [formAdd] = Form.useForm();
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [StorageResponse, setStorageResponse] = useState(null);

  const handleStorageResponse = (response) => {
    setStorageResponse(response);
  };

  const handleSubmit = (data) => {
    // Format time to minutes from midnight
    const formatTimeToMinutes = (time) => {
      if (!time) return null;
      const hours = time.hour();
      const minutes = time.minute();
      return hours * 60 + minutes;
    };

    let formData = JSON.stringify({
      name: data?.name,
      description: data?.description,
      alertTrigger: data?.trigger,
      temperatureMaxInCelsius: SelectForm === "Hot" ? 0 : data?.temperatureMaxInCelsius,
      temperatureMinInCelsius: SelectForm === "Hot" ? 0 : data?.temperatureMinInCelsius === undefined ? 0 : data?.temperatureMinInCelsius,
      hot: SelectForm === "Hot" ? true : false,
      sensorDTOList: data.SensorID ? [{ id: data.SensorID }] : null,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: data?.institutionId,
      },
    });

    // First create the storage
    StorageSuggestionApi.CreateStorage(formData)
      .then((storageResponse) => {
        setLoadings(false);

        // Adjust this based on your actual API response structure
      const storageId = storageResponse?.data?.id || storageResponse?.id || storageResponse?.payload?.id;
      
      console.log("Storage created with ID:", storageId); // Debug log
        
        // If Hot storage is selected, create Hot Hold Config
        if (SelectForm === "Hot" && data?.operatingDays && data?.openingTime && data?.closingTime && data?.checkFrequency) {
          // Format operating days - convert array to comma-separated string
          const operatingDays = data.operatingDays.join(',');
          
          const hotHoldConfigData = {
            storageDTO: {
               id: storageId
            },
            operatingDays: operatingDays,
            openingTimeMinutes: formatTimeToMinutes(data.openingTime),
            closingTimeMinutes: formatTimeToMinutes(data.closingTime),
            checkFrequencyMinutes: data.checkFrequency
          };

          // Call the Hot Hold Config API
          ReportsApi.SaveDashboardHotHoldConfig(hotHoldConfigData)
            .then(() => {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                description: "Storage and Hot Hold Configuration created successfully",
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#b3ffb3",
                  color: "green",
                },
              });
              return navigate("/masters/storage");
            })
            .catch((err) => {
              console.error("Hot Hold Config Error:", err);
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Warning</span>,
                description: "Storage created but Hot Hold configuration failed. Please configure manually.",
                closeIcon: false,
                duration: 5,
                style: {
                  backgroundColor: "#fff7e6",
                  color: "#d48806",
                },
              });
              return navigate("/masters/storage");
            });
        } else {
          // If Cold storage, just show success
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
            description: "Storage created successfully",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          return navigate("/masters/storage");
        }
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  const [isRecording, setIsRecording] = useState(false);
  const [isRecording2, setIsRecording2] = useState(false);
  const startRecording = (fieldN) => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      let fieldName = fieldN;
      formAdd.setFieldsValue({
        [fieldName]: transcript,
      });
    };
    recognition.start();
    if (fieldN === 'temperatureMinInCelsius') {
      setIsRecording(true);
    } else if (fieldN === 'temperatureMaxInCelsius') {
      setIsRecording2(true);
    }
  };

  const stopRecording = () => {
    setIsRecording(false);
    setIsRecording2(false);
  };

  const [SelectForm, SetSelectForm] = useState('Cold');
  const handleChangeModify = (item) => {
    SetSelectForm(item);
    // Reset form fields when switching between Hot and Cold
    if (item === 'Hot') {
      formAdd.setFieldsValue({
        temperatureMinInCelsius: undefined,
        temperatureMaxInCelsius: undefined,
      });
    } else {
      formAdd.setFieldsValue({
        operatingDays: undefined,
        openingTime: undefined,
        closingTime: undefined,
        checkFrequency: undefined,
      });
    }
  };

  // Day options for operating days
  const dayOptions = [
    { label: 'Monday', value: 'MONDAY' },
    { label: 'Tuesday', value: 'TUESDAY' },
    { label: 'Wednesday', value: 'WEDNESDAY' },
    { label: 'Thursday', value: 'THURSDAY' },
    { label: 'Friday', value: 'FRIDAY' },
    { label: 'Saturday', value: 'SATURDAY' },
    { label: 'Sunday', value: 'SUNDAY' },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            form={formAdd}
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={24} md={24} className="pb-3">
                  <div className="d-flex">
                    <Radio
                      style={{ paddingRight: '30px' }}
                      checked={SelectForm === "Cold"}
                      onChange={() => handleChangeModify("Cold")}
                    >
                      Cold Unit
                    </Radio>
                    <Radio
                      checked={SelectForm === "Hot"}
                      onChange={() => handleChangeModify("Hot")}
                    >
                      Hot Unit
                    </Radio>
                  </div>
                </Col>
                
                <Col lg={8} md={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                
                <Col lg={8} md={12} className={SelectForm === "Hot" ? 'd-none' : ''}>
                  <Form.Item
                    name="temperatureMinInCelsius"
                    label="Temperature Min Celsius"
                    className="text-lable"
                    rules={SelectForm === "Cold" ? [
                      {
                        required: true,
                        message: "Please enter Temperature Min Celsius",
                      },
                    ] : []}
                  >
                    <Input
                      type="number"
                      placeholder="0"
                      className="control-input col-8"
                      style={{
                        border: 'none',
                        textAlign: 'end',
                        padding: '0px'
                      }}
                      addonAfter={
                        <>
                          <Button
                            className="StockTempClass"
                            style={{
                              border: 'none',
                              padding: 0,
                              paddingTop: '0px',
                              margin: 0,
                              background: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            'C
                          </Button>
                          <Button
                            onMouseDown={() => startRecording('temperatureMinInCelsius')}
                            onMouseUp={stopRecording}
                            onMouseLeave={stopRecording}
                            style={{
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              marginLeft: '10px',
                              paddingLeft: '5px',
                              paddingBottom: '5px',
                              background: 'none',
                              borderRadius: '0px',
                              borderLeft: '1px solid #d9d9d9',
                              cursor: 'pointer',
                            }}
                          >
                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                          </Button>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
                
                <Col lg={8} md={12} className={SelectForm === "Hot" ? 'd-none' : ''}>
                  <Form.Item
                    name="temperatureMaxInCelsius"
                    label="Temperature Max Celsius"
                    className="text-lable"
                    rules={SelectForm === "Cold" ? [
                      {
                        required: true,
                        message: "Please enter Temperature Max Celsius",
                      },
                    ] : []}
                  >
                    <Input
                      type="number"
                      placeholder="0"
                      className="control-input col-8"
                      style={{
                        border: 'none',
                        textAlign: 'end',
                        padding: '0px'
                      }}
                      addonAfter={
                        <>
                          <Button
                            className="StockTempClass"
                            style={{
                              border: 'none',
                              padding: 0,
                              paddingTop: '0px',
                              margin: 0,
                              background: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            'C
                          </Button>
                          <Button
                            onMouseDown={() => startRecording('temperatureMaxInCelsius')}
                            onMouseUp={stopRecording}
                            onMouseLeave={stopRecording}
                            style={{
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              marginLeft: '10px',
                              paddingLeft: '5px',
                              paddingBottom: '5px',
                              background: 'none',
                              borderRadius: '0px',
                              borderLeft: '1px solid #d9d9d9',
                              cursor: 'pointer',
                            }}
                          >
                            {isRecording2 ? <LoadingOutlined /> : <AudioOutlined />}
                          </Button>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>

                {/* Hot Hold Configuration Fields - Only visible when Hot is selected */}
                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="operatingDays"
                    label="Operating Days"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please select at least one operating day",
                      },
                    ] : []}
                  >
                    <Select
                      mode="multiple"
                      className="control-Select mb-1"
                      placeholder="Select Operating Days"
                      options={dayOptions}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="openingTime"
                    label="Opening Time"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please select opening time",
                      },
                    ] : []}
                  >
                    <TimePicker
                      className="control-input"
                      placeholder="Select Opening Time"
                      format="HH:mm"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="closingTime"
                    label="Closing Time"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please select closing time",
                      },
                    ] : []}
                  >
                    <TimePicker
                      className="control-input"
                      placeholder="Select Closing Time"
                      format="HH:mm"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                <Form.Item
                  name="checkFrequency"
                  label="Check Frequency (minutes)"
                  className="text-lable"
                  rules={SelectForm === "Hot" ? [
                    {
                      required: true,
                      message: "Please enter check frequency",
                    },
                    {
                      type: 'number',
                      min: 1,
                      message: "Frequency must be at least 1 minute",
                    },
                  ] : []}
                >
                  <Input
                    type="number"
                    placeholder="Enter minutes (e.g., 60 for every hour)"
                    className="control-input"
                    min={1}
                    step={1}
                    addonAfter="minutes"
                    onChange={(e) => {
                      // Ensure value is a number
                      const value = e.target.value;
                      if (value !== '' && !isNaN(value) && Number(value) >= 0) {
                        formAdd.setFieldsValue({
                          checkFrequency: Number(value)
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>

                <Col lg={8} md={12}>
                  <DepartmentDropdown />
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Hot" ? 'd-none' : ''}>
                  <SensorsStockPage SensprValid={SelectForm === "Hot" ? false : true} onStorageResponse={handleStorageResponse} />
                </Col>
                
                <Col lg={8} md={8}>
                  <Form.Item
                    name="trigger"
                    label="Want to trigger an alert"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Trigger",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Trigger"
                    >
                      <Select.Option value={true}>
                        Yes
                      </Select.Option>
                      <Select.Option value={false}>
                        No
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                
                <Col lg={20} md={12}>
                  <Form.Item
                    name="description"
                    label="Description"
                    className="text-lable mt-2"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Description",
                      },
                    ]}
                  >
                    <TextArea
                      placeholder="Description"
                      className="form-control control-input p-3"
                      rows={3}
                      style={{ resize: "none" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px"
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Create {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AddStorageList;